const MONTHS_PT = [
    "jan", "fev", "mar", "abr", "mai", "jun",
    "jul", "ago", "set", "out", "nov", "dez",
]

/**
 * Formats a date into a short human string in pt-BR (e.g. "18 nov 2025").
 * Accepts "20251118" or "2025-11-18" (any non-digit separators are ignored).
 */
export const formatEventDate = (value?: string): string => {
    if (!value) return ""
    const digits = String(value).replace(/\D/g, "")
    if (digits.length < 8) return String(value)
    const year = digits.slice(0, 4)
    const month = Number(digits.slice(4, 6))
    const day = digits.slice(6, 8)
    if (month < 1 || month > 12) return String(value)
    return `${day} ${MONTHS_PT[month - 1]} ${year}`
}

/**
 * Turns a maturing-product code like "CRA - 20251118" into a human-readable
 * event: { code: "CRA", dateText: "18 nov 2025" }.
 */
export const parseMaturityProduct = (
    nameProduct?: string,
): { code: string; dateText: string | null } => {
    if (!nameProduct) return { code: "", dateText: null }
    const codeMatch = nameProduct.match(/^[A-Za-zÀ-ú]+/)
    const code = codeMatch ? codeMatch[0].toUpperCase() : nameProduct.trim()
    const dateMatch = nameProduct.match(/(\d{8})/)
    const dateText = dateMatch ? formatEventDate(dateMatch[1]) : null
    return { code, dateText }
}
